module.exports = __webpack_public_path__ + "static/media/nikolaTim.89d39039.jpg";